<div class="pest-risk-levels-container">
  @for(eachRiskLevel of activeRiskLevels; track eachRiskLevel.riskLevel) {
    <div class="week-line"
      [style.border-left-width]="'2px'"
      [style.border-left-style]="'solid'"
      [style.border-left-color]="eachRiskLevel.riskLevel == 3 ? '#E11900' : eachRiskLevel.riskLevel == 1 ? '#EE9F00' : '#000'"
    >
      <div class="days-container">
        <span class="day-names" [style.color]="eachRiskLevel.riskLevel == 3 ? '#E11900' : eachRiskLevel.riskLevel == 1 ? '#EE9F00' : '#000'">
          {{ eachRiskLevel.dateRangeDayNamesString }}
        </span>
        <span class="dates">
          {{ eachRiskLevel.dateRangeDatesString }}
        </span>
      </div>
      @if (showRiskBadges) {
        @if (eachRiskLevel.riskLevel == 1) {
          <span class="risk-badge risk-badge--low">
            {{ 'doktar_app.home.disease_risk_level_low' | translate }}
          </span>
        } @else if (eachRiskLevel.riskLevel == 3) {
          <span class="risk-badge risk-badge--high">
            {{ 'doktar_app.home.disease_risk_level_high' | translate }}
          </span>
        }
      }
    </div>
  }
</div>
